import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/Button/Button";
import DataTable from "@/components/Datatable/Datatable";
import { useStages } from "../../hooks/useStages";
import { createStageColumns } from "../StageColumns/StageColumns";
import StageFilters from "../StageFilters/StageFilters";
import ViewStageDrawer from "../ViewStageDrawer/ViewStageDrawer";

const StageList: React.FC = () => {
  const navigate = useNavigate();
  const {
    stages,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    searchTerm,
    status,
    handlePaginationChange,
    handleSortingChange,
    handleSearchChange,
    handleStatusChange,
    viewingStage,
    openView,
    closeView,
  } = useStages();

  const columns = useMemo(
    () => createStageColumns({ onView: openView }),
    [openView],
  );

  return (
    <>
      <MainPageWrapper
        actions={
          <Button
            onClick={() => navigate("/admin/stages/permissions")}
            variant="outline"
          >
            Manage Permissions
          </Button>
        }
        error={error}
        subtitle="Membership tiers assigned by CARA Stage Growth subscriptions."
        title="Stages"
      >
        <StageFilters
          onSearchChange={handleSearchChange}
          onStatusChange={handleStatusChange}
          searchTerm={searchTerm}
          status={status}
        />

        <DataTable
          columns={columns}
          data={stages}
          error={error}
          loading={loading}
          noDataMessage="No stages found"
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.uuid}
          sorting={sorting}
          totalCount={totalCount}
        />
      </MainPageWrapper>

      {viewingStage && (
        <ViewStageDrawer
          isOpen={!!viewingStage}
          onClose={closeView}
          stage={viewingStage}
        />
      )}
    </>
  );
};

export default StageList;
